import { FC } from 'react';

import { ReactElement } from 'react-markdown/lib/react-markdown';

import { Badge, Button, Card, Cell, CellText, HSpacingContainer, useBreakpoint } from '@hh.ru/magritte-ui';
import { ChevronRightOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

export const HelpModalButton: FC<{
    icon: ReactElement;
    title: string;
    subtitle?: string;
    badgeValue?: string;
    buttonLabel?: string;
    href?: string;
    onClick?: () => void;
}> = ({ icon, title, subtitle, badgeValue, buttonLabel, href, onClick }) => {
    const { isMobile } = useBreakpoint();

    return (
        <Card
            Element={href ? 'a' : 'div'}
            target={href ? '_blank' : undefined}
            padding={12}
            borderRadius={24}
            borderStyle="neutral"
            borderWidth="default"
            shadow="level-0"
            pressEnabled
            increaseShadow
            stretched
            href={href}
            onClick={onClick}
        >
            <Cell
                left={icon}
                right={
                    <HSpacingContainer default={8}>
                        {!!badgeValue && <Badge size="small">{badgeValue}</Badge>}
                        {isMobile && <ChevronRightOutlinedSize24 initialColor="secondary" />}
                        {!isMobile && buttonLabel && (
                            <Button onClick={onClick} mode="secondary" data-qa="help_card_button">
                                {buttonLabel}
                            </Button>
                        )}
                    </HSpacingContainer>
                }
            >
                <CellText>{title}</CellText>
                {subtitle && <CellText type="subtitle">{subtitle}</CellText>}
            </Cell>
        </Card>
    );
};
